/**
 * Brand-owned, honest placeholder artwork. This is deliberately graphic,
 * never a fabricated photograph of a real business or its staff.
 * The same 4:3 artwork fills missing or failed cover slots site-wide.
 */
const THEMES = {
  lgbtq: { bg: "#F8D3E7", ink: "#542044", accent: "#D53883", pale: "#FFF0F8" },
  food: { bg: "#E8D5C0", ink: "#443024", accent: "#B8693E", pale: "#F5EAE0" },
  drink: { bg: "#DEC9CB", ink: "#522E33", accent: "#974F60", pale: "#F4E7E8" },
  experiences: { bg: "#CCD9D4", ink: "#223C3D", accent: "#527F73", pale: "#E8F1EC" },
  culture: { bg: "#D5D7DF", ink: "#303848", accent: "#687AA1", pale: "#E8E9F0" },
  shop: { bg: "#E8D9C8", ink: "#493B32", accent: "#A47D59", pale: "#F5EDE3" },
  services: { bg: "#D8D9D6", ink: "#323833", accent: "#6C8073", pale: "#EDF0EB" },
  default: { bg: "#DBD9D2", ink: "#34342F", accent: "#888273", pale: "#F2F0EB" },
};
const themeFor = (item, explicit) => {
  if (explicit && THEMES[explicit]) return explicit;
  const tag = `${item?.category || ""} ${item?.label || ""} ${item?.subcategory || ""} ${item?.type || ""}`.toLowerCase();
  if (/lgbtq|queer|drag|pride/.test(tag)) return "lgbtq";
  if (/cafe|coffee|food|bakery|gastronomy|restaurant|eat|comida/.test(tag)) return "food";
  if (/nightlife|cocktail|drink|bar|beber/.test(tag)) return "drink";
  if (/experience|tour|activity|adventure/.test(tag)) return "experiences";
  if (/art|gallery|culture|museum|historic/.test(tag)) return "culture";
  if (/shop|store|market|boutique/.test(tag)) return "shop";
  if (/service|barber|salon|repair/.test(tag)) return "services";
  return "default";
};

export default function ListingPhotoPlaceholder({ item, lang = "en", theme, className = "" }) {
  const palette = THEMES[themeFor(item, theme)];
  const es = lang === "es";
  const words = es ? ["FOTO", "PRÓXIMAMENTE"] : ["PHOTO", "COMING SOON"];
  return (
    <svg viewBox="0 0 800 600" role="img"
      aria-label={es ? "Imagen de referencia; fotografía real pendiente" : "Editorial placeholder; real business photo coming soon"}
      preserveAspectRatio="xMidYMid slice" className={`block h-full w-full ${className}`}>
      <rect width="800" height="600" fill={palette.bg} />
      <circle cx="665" cy="90" r="210" fill={palette.pale} opacity=".85" />
      <circle cx="-45" cy="560" r="310" fill={palette.accent} opacity=".20" />
      <path d="M0 500 L475 0 L535 0 L65 600 Z" fill={palette.pale} opacity=".55" />
      <path d="M170 600 L735 0" stroke={palette.ink} strokeWidth="2" opacity=".12" />
      <path d="M215 600 L780 0" stroke={palette.ink} strokeWidth="2" opacity=".12" />
      <rect x="45" y="45" width="710" height="510" fill="none" stroke={palette.ink} strokeWidth="2" opacity=".38" />
      <text x="75" y="96" fill={palette.ink} fontFamily="Arial, Helvetica, sans-serif" fontSize="23" fontWeight="800" letterSpacing="3">YA TÚ SABES PR</text>
      <path d="M77 122 h110" stroke={palette.accent} strokeWidth="7" />
      <circle cx="400" cy="286" r="92" fill={palette.pale} opacity=".86" />
      <rect x="348" y="256" width="104" height="66" rx="8" fill="none" stroke={palette.ink} strokeWidth="7" />
      <path d="M362 255 l17 -22 h41 l17 22" fill="none" stroke={palette.ink} strokeWidth="7" strokeLinejoin="round" />
      <circle cx="400" cy="290" r="21" fill="none" stroke={palette.ink} strokeWidth="7" />
      <text x="400" y="416" textAnchor="middle" fill={palette.ink} fontFamily="Arial, Helvetica, sans-serif" fontSize="36" fontWeight="800" letterSpacing="4">{words[0]}</text>
      <text x="400" y="456" textAnchor="middle" fill={palette.ink} fontFamily="Arial, Helvetica, sans-serif" fontSize="25" fontWeight="700" letterSpacing="3">{words[1]}</text>
      <text x="75" y="526" fill={palette.ink} fontFamily="Arial, Helvetica, sans-serif" fontSize="17" fontWeight="600" letterSpacing="2" opacity=".75">{es ? "GUÍA LOCAL · PUERTO RICO" : "PUERTO RICO · LOCAL GUIDE"}</text>
      <path d="M645 522 h100" stroke={palette.accent} strokeWidth="6" />
    </svg>
  );
}
